import { useCallback } from "react";

export type EventEmitter = <T = unknown>(
  eventName: string,
  payload: Record<string, unknown> | boolean,
) => T | Promise<T> | void;

export function useEventEmitter(onEvent?: EventEmitter) {
  return useCallback(
    async <T = unknown>(
      eventName: string,
      payload: Record<string, unknown> | boolean,
    ) => {
      const result = onEvent?.(eventName, payload) as T | Promise<T> | void;
      if (result === undefined) return undefined;
      return Promise.resolve(result);
    },
    [onEvent],
  );
}
